export * as app from "./app";
export * as calendar from "./calendar";
export * as classroom from "./classroom";
export * as course from "./course";
export * as custom from "./custom";
export * as custom2 from "./custom-queries";
export * as exam from "./exam";
export * as favorites from "./favorites";
export * as issues from "./issues";
export * as item from "./item";
export * as jobs from "./jobs";
export * as launch from "./launch";
export * as media from "./media";
export * as objective from "./objective";
export * as relative from "./relative";
export * as resource from "./resource";
export * as reviews from "./reviews";
export * as role from "./role";
export * as search from "./search";
export * as snapshot from "./snapshot";
export * as task from "./task";
export * as unit from "./unit";
export * as user from "./user";
export * as vocabulary from "./vocabulary";
export * as worklog from "./worklog";
export * as workspace from "./workspace";

export interface Params {
  label?: string;
  fields?: string;
}

export type QueryFn = (params?: Params) => string;

export const fields = (strings: TemplateStringsArray, ...vars: string[]) => {
  return `${vars.map((value, index) => {
    return `${strings[index]}${value}`;
  })}${strings[strings.length - 1]}`;
};

export const query = (
  label: string,
  fieldName: string,
  inputType: string,
  fields: string,
) => `
query ${label}($input: ${inputType}) {
  ${fieldName}(input: $input) {
    ${fields}
  }
}`;

export const mutation = (
  label: string,
  fieldName: string,
  inputType: string,
  fields: string,
) => `
mutation ${label}($input: ${inputType}) {
  ${fieldName}(input: $input) {
    ${fields}
  }
}`;
